"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SuccessIcon_1 = __importDefault(require("./Icons/SuccessIcon"));
var ErrorIcon_1 = __importDefault(require("./Icons/ErrorIcon"));
var InfoIcon_1 = __importDefault(require("./Icons/InfoIcon"));
var GenericMessage = function (_a) {
    var _b = _a.status, status = _b === void 0 ? 'info' : _b, props = __rest(_a, ["status"]);
    return (react_1.default.createElement(Container, null,
        react_1.default.createElement(MessageBox, { "$open": props.open },
            status === 'success' && (react_1.default.createElement(SuccessIcon_1.default, { style: { marginRight: '10px' } })),
            status === 'error' && (react_1.default.createElement(ErrorIcon_1.default, { style: { marginRight: '10px' } })),
            status === 'info' && (react_1.default.createElement(InfoIcon_1.default, { style: { marginRight: '10px' } })),
            props.text)));
};
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  heigth: 40px;\n  z-index: 10;\n"], ["\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: 100%;\n  heigth: 40px;\n  z-index: 10;\n"])));
var MessageBox = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n  font-size: 16px;\n  width: fit-content;\n  padding: 9px 12px;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08),\n    0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease-out;\n  opacity: 0;\n  margin-top: -40px;\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n  font-size: 16px;\n  width: fit-content;\n  padding: 9px 12px;\n  background: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08),\n    0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease-out;\n  opacity: 0;\n  margin-top: -40px;\n\n  ", "\n"])), function (props) {
    return props.$open &&
        "\n      opacity: 1;\n      margin-top: 30px\n  ";
});
exports.default = GenericMessage;
var templateObject_1, templateObject_2;
